import { CITATIONS } from 'common/endpoints';
import BaseServiceRetryWrapper from './baseRetry';

class CitationService extends BaseServiceRetryWrapper {
  /**
   * Delete a citation reference by ID
   * @param citationId - The ID of the citation to delete
   * @returns Promise with the delete response
   */
  deleteCitation = (citationId: number) => this.delete(CITATIONS.deleteCitation(citationId));
}

export default CitationService;

